import { render, staticRenderFns } from "./PermissionRequest.vue?vue&type=template&id=4f577473&scoped=true"
import script from "./PermissionRequest.vue?vue&type=script&lang=js"
export * from "./PermissionRequest.vue?vue&type=script&lang=js"
import style0 from "./PermissionRequest.vue?vue&type=style&index=0&id=4f577473&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f577473",
  null
  
)

export default component.exports